const garSubscription = {
  garSubscriptions: "GAR Subscriptions",
  subscriptionDetails: "Subscription details",
  subscriptionUpdate: "Edit subscription",
  updateWarning:
    "Warning: once a subscription has started, the only allowed changes are to extend the end date or increase the number of licenses.",
  title: "GAR School Subscriptions",
  startValidity: "Subscription start",
  endValidity: "Subscription end",
  affectationType: "Assigned to",
  licences: "Licences",
  subscribeEstablishment: "Subscribe a GAR school",
  projectCode: "Project code",
  projectCodeError:
    "The project code provided does not exist and was therefore not saved.",
  maxSubscriptionStart:
    "The subscription start date cannot be more than 10 years after the subscription creation date.",
  searchEstablishment: "Search for a school",
  estNameOrUAI: "School name or UAI",
  deptNumber: "Department number (optional)",
  searchNoResult: "No schools match your search.",
  licencesType: "Licence type",
  global: "Global",
  targetPublic: "By target audience",
  nbGlobalLicences: "Total licenses",
  nbStudentLicences: "Student licenses",
  nbTeacherLicences: "Teacher licenses",
  nbProfDocLicences: "Teacher-librarian licenses",
  nbOtherStaffLicences: "Other staff licenses",
  unlimited: "Unlimited",
  OR: "OR",
  deleteSubscription: "Delete subscription",
  deleteSubscriptionVerif: "Delete this subscription?",
};

export default garSubscription;
